import moment from "moment";
export function getDateFormat(date) {
  //console.log(date);
  //return date.toJSON().slice(0, 10);
  return moment(String(date)).format("YYYY-MM-DD");
}
export function getTimeFromDateFormat(date) {
  return date.slice(10, 16);
}
export function getTimeFormat(time) {
  return time.slice(0, 5);
}
export function formatDateDisplay(date) {
  //return moment(String(date)).format("Do MMMM YYYY");
  return moment(String(date)).format("DD/MM/YYYY");
}
export function formatDateTimeDisplay(date) {
  //return moment(String(date)).format("Do MMMM YYYY, h:mm:ss a");
  return moment(String(date)).format("DD/MM/YYYY, h:mma");
}